import { MDBContainer } from "mdb-react-ui-kit";
import { useState } from "react";
import apiServices from "../../services/api.services";

//common component
import Header from "../../components/header/header-one";
import Sidebar from "../../components/sidebar/sidebar-one";
import TransationListing from "./component/listing";
import Gif from "../../assets/fonts/loader/loader.gif";
//service
import useWindowDimensions from "../../components/common/window-dimension";
import { useEffect } from "react";
//data for api

export default function Transaction() {
  const [loader, setLoader] = useState(false);
  const [openSideBar, setOpenSideBar] = useState(true);
  const { height, width } = useWindowDimensions();
  const [type, setType] = useState("all"); //control role
  const [start, setStart] = useState(0); //paginate
  const [length, setLength] = useState(10); //paginate
  const [order, setOrder] = useState("desc"); // asc or desc
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(); //filter date
  const [endDate, setEndDate] = useState(); //filter date
  //date for render
  const [listingData, setListingData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayRecords, setDisplayRecords] = useState(0);

  useEffect(() => {
    if (width >= "767") {
      setOpenSideBar(true);
    } else {
      setOpenSideBar(false);
    }
  }, [width]);

  useEffect(() => {
    getListing();
    if (search === "") {
      // setLoader(true);
    }
  }, [search, length, start]);

  const getListing = async () => {
    const response = await apiServices.summaryReport({
      type,
      search,
      order,
      startDate,
      endDate,
      length,
      start,
      status: "completed",
      wallet_type: "all",
    });
    if (response) {
      setLoader(false);
      setListingData(response.aaData);
      setTotalRecords(response.iTotalRecords);
      setDisplayRecords(response.iTotalDisplayRecords);
    }
  };

  const handleOpenSideBar = () => {
    setOpenSideBar(!openSideBar);
  };

  return (
    <MDBContainer className="main-container" breakpoint="none">
      <div className="grid-container">
        <Sidebar isOpen={openSideBar} handleSideBar={handleOpenSideBar} />

        <div className="page-container">
          <Header handleSideBar={handleOpenSideBar} />
          {loader ? (
            <div className="loader">
              <img src={Gif} />
            </div>
          ) : (
            <TransationListing
              length={length}
              start={start}
              listingData={listingData}
              totalRecords={totalRecords}
              displayRecords={displayRecords}
              setListingData={setListingData}
              setSearch={setSearch}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setOrder={setOrder}
              setLength={setLength}
              setStart={setStart}
            />
          )}
        </div>
      </div>
    </MDBContainer>
  );
}
